/**
 * 接口视角的开关与面板状态。**不引登记表**：顶栏开关、Field / 表头的标记都只读这里，
 * 登记表与面板在开关打开后才按需加载，不进管端主包。
 */
import { useSyncExternalStore } from "react";

/**
 * 接口视角的界面状态：开关、面板、选取模式、当前打开的那一项。
 *
 * 开关按人记在浏览器里，默认关。关着时页面上什么都不多（Field / 表头不出标记），运营无感。
 * 用一个模块级 store 而不是 React context：标记散在每个 Field 和表头里，挂 context 要穿透整棵树。
 */
export interface LensState {
  on: boolean;
  panel: boolean;
  pick: boolean;
  /** 面板里打开的那一项（登记 id） */
  sel: string | null;
  /**
   * 从表格某一行选中时，那一行的行标识（关卡号、星数、卡包 id…，见 DataTable 的 lensRow）。
   * 面板按它取那一行所在的块、数组里那一行的值；从标记、列表、搜索打开时为 null，取第一项做例子
   */
  row: string | null;
}

const KEY = "apiLens";
let state: LensState = { on: readOn(), panel: false, pick: false, sel: null, row: null };
const subs = new Set<() => void>();

function readOn(): boolean {
  try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
}

export function lensSet(patch: Partial<LensState>): void {
  state = { ...state, ...patch };
  if ("on" in patch) { try { localStorage.setItem(KEY, patch.on ? "1" : "0"); } catch { /* 无痕模式等：只是不记住 */ } }
  for (const f of subs) f();
}

export function useLens(): LensState {
  return useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => state);
}

